module.exports = __webpack_public_path__ + "static/media/ConferirPayShared.72fe2f33.svg";